'use strict';

angular.module('m42AccessControlServiceFrontendApp')
    .controller('MyaccountTokensCreatedCtrl', ['token', '$scope', '$modalInstance',
        function (token, $scope, $modalInstance) {

            $scope.token = token;

            $scope.ok = function () {
                $modalInstance.close();
            };

        }]);
